export default "__VITE_ASSET__DgKzpmT5__"